/* eslint-disable */
import React from 'react';
import 'react-dates/initialize';
import { DateRangePicker, SingleDatePicker } from 'react-dates';
import {
	Button,
	Popover
} from '@material-ui/core';
import SweetAlert from 'sweetalert-react';
import moment from 'moment';
import $ from 'jquery';
import { isMobile } from 'react-device-detect';
import TranslationHelper from '../common/TranslationHelper';
import AjaxHelper from '../common/AjaxHelper';
import UIHelper from '../common/UIHelper';

import '../../node_modules/react-dates/lib/css/_datepicker.css';
import '../css/daterangeselector.css';

export default class DateRangeSelector extends React.Component {
	constructor(props) {
		super(props);
		props.timezone && moment.tz.setDefault(props.timezone);
		const { unavailableDateRanges } = props;
		this.state = {
			focusedInput: null,
			startDate: this.props.searchParams && this.props.searchParams.dateRange.startDate ? moment(this.props.searchParams.dateRange.startDate) : (props.initialstartdate || props.initialDate),
			endDate: this.props.searchParams && this.props.searchParams.dateRange.endDate ? moment(this.props.searchParams.dateRange.endDate) : props.initialenddate,
			singleDate: this.props.searchParams && this.props.searchParams.singleDate ? moment(this.props.searchParams.singleDate) : props.initialenddate,
			display: 'none',
            selectBtnLabel: this.props.searchParams && (this.props.searchParams.dateRange.startDate || this.props.searchParams.singleDate) ? `${moment(this.props.searchParams.dateRange.startDate ? this.props.searchParams.dateRange.startDate : this.props.searchParams.singleDate).format(this.props.searchParams.dateRange.endDate ? 'DD MMM' : 'DD MMM YYYY')}${this.props.searchParams.dateRange.endDate ? ` - ${moment(this.props.searchParams.dateRange.endDate).format('DD MMM')}` : ''}` : TranslationHelper.getValue('customer_account.dateRangeSelector.selectDates'),
			showClearDates: this.props.showcleardates || false,
			readOnly: this.props.readOnly || false,
			showBlockedDays: true,
			weekDaysAvailable: [1, 2, 3, 4, 5, 6],
			unavailableDateRanges,
			selectRangeOption: 'days',
			showDateRange: true,
			focused: false,
			initialLoad: true,
			availableToClearDates: true,
			showDateRangeError: false,
			dateRangeErrorText: '',
			anchorEl: null
		};
		this.blockedDay = {};
		this.callback = props.callback;
		this.updatable = true;
		this.onDatesChange = this.onDatesChange.bind(this);
		this.onFocusChange = this.onFocusChange.bind(this);

		this.getDateRange = this.getDateRange.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.isDayBlocked = this.isDayBlocked.bind(this);
		this.handleDayChange = this.handleDayChange.bind(this);
		this.onSingleDateFocusChange = this.onSingleDateFocusChange.bind(this);
		this.handleSingleDateChange = this.handleSingleDateChange.bind(this);
	}

	componentWillMount() {
		AjaxHelper.invokeServerAPI('/api/config', { 'calendar.dateSelection': 1 }, (err, data) => {
			if (!err) {
				this.setState({
					showDateRange: data['calendar.dateSelection'] !== 'Start Date Only'
				});
			}
		});
	}

	componentDidMount() {
		const elemStartDate = $('#startDateInput');
		const elemEndDate = $('#endDateInput');
		if (this.props.highlightdate) {
			elemStartDate.css('color', 'red').addClass('invalid');
			elemEndDate.css('color', 'red').addClass('invalid');
		} else {
			elemStartDate.css('color', '#565a5c').removeClass('invalid');
			elemEndDate.css('color', '#565a5c').removeClass('invalid');
		}
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.highlightdate) {
			$('#startDateInput').css('color', 'red');
			$('#endDateInput').css('color', 'red');
		} else {
			$('#startDateInput').css('color', '#565a5c');
			$('#endDateInput').css('color', '#565a5c');
		}
	}

	componentDidUpdate(prevProps) {
		const { searchParams } = this.props;
		if (searchParams && searchParams.dateRange && searchParams.dateRange.startDate && searchParams.dateRange.startDate !== prevProps.searchParams.dateRange.startDate && this.state.initialLoad) {
			this.setState({
				selectBtnLabel: `${moment(searchParams.dateRange.startDate).format(searchParams.dateRange.endDate ? 'DD MMM' : 'DD MMM YYYY')}${searchParams.dateRange.endDate ? ` - ${moment(searchParams.dateRange.endDate).format('DD MMM')}` : ''}`,
				initialLoad: false,

			});
		} else if (searchParams && searchParams.clearDates && this.state.availableToClearDates) {
			this.setState({ startDate: null, endDate: null, availableToClearDates: false });
		}
	}

	getDateRange = () => ({
		startDate: this.state.startDate.toDate(),
		endDate: this.state.endDate.toDate(),
	});

	handleClick = (event) => {
		this.setState({ anchorEl: event.currentTarget });
	};

	handleClose = () => {
		this.setState({ anchorEl: null });
	};

	isDayBlocked(day) {
		let res = null;
		const dateFormat = day.format();
		if (this.blockedDay[dateFormat] !== undefined) return this.blockedDay[dateFormat];
		if (this.state.showBlockedDays && this.props.weekDaysAvailable && this.state.unavailableDateRanges) {
			const weekdayUnavailable = !this.props.weekDaysAvailable.includes(day.day());
			let dateRangeUnavailable = false;

			for (const dateRange of this.state.unavailableDateRanges) {
				if (/(Booked|orders)/.test(dateRange.type) && dateRange.startDate) {
					dateRangeUnavailable = day.isBetween(
						dateRange.startDate,
						dateRange.endDate,
						'day',
						'[]'
					);
				} else if (dateRange.type === 'Unavailable' && dateRange.startDate) {
					dateRangeUnavailable = day.isBetween(
						dateRange.startDate,
						dateRange.endDate,
						'day',
						'[]'
					);

					if (dateRange.isAvailable && dateRange.startDate) {
						dateRangeUnavailable = day.isBetween(
							dateRange.startDate,
							dateRange.endDate,
							'day',
							'[]'
						);
					}
				}

				if (dateRangeUnavailable) {
					break;
				}
			}

			res = weekdayUnavailable || dateRangeUnavailable;
		}
		if (res === null) res = false;
		this.blockedDay[dateFormat] = res;
		return res;
	}

	handleDayChange({ startDate, endDate }) {
		// if startDate is same as endDate, both will be reference type so that eight should be cloned.
		if (startDate && endDate && startDate === endDate) startDate = endDate.clone();
		if (startDate) {
			startDate = startDate.set({
				hour: 0, minute: 0, second: 0, millisecond: 0
			});
		}
		if (endDate) {
			endDate = endDate.set({
				hour: 23, minute: 59, second: 59, millisecond: 0
			});
		}

		const {
			callback, pageActiveCallback, mobileModalVisible, setMobileModalVisibility
		} = this.props;
		if (this.state.prevFocusedInput === 'endDate') {
			$('#selectBtn').trigger('click'); // .removeClass('inlineDisplay').addClass('hide');
			this.setState({
				startDate, // && stateDateWrapper(startDate),
				endDate, // && stateDateWrapper(endDate),
				focusedInput: null,
				prevFocusedInput: null,
				selectBtnLabel: (startDate && endDate) ? (`${startDate.format('DD MMM')} - ${endDate.format('DD MMM')}`)
					: TranslationHelper.getValue('customer_account.dateRangeSelector.selectDates'),
				availableToClearDates: true,

			});
			if (callback && startDate && endDate) {
				if (mobileModalVisible) {
					setMobileModalVisibility(false);
				}
				callback({
					dateRange: {
						startDate: startDate.toDate(),
						endDate: endDate.toDate()
					}
				});
			}
		} else {
			if (!startDate && !endDate && !this.state.focusedInput) {
				$('#selectBtn').trigger('click');

				if (callback) {
					if (mobileModalVisible) {
						setMobileModalVisibility(false);
					}
					pageActiveCallback && pageActiveCallback(1);
					callback({
						dateRange: {
							startDate: null,
							endDate: null
						}
					});
				}
			}
			this.setState({
				startDate, // && stateDateWrapper(startDate),
				endDate, // && stateDateWrapper(endDate),
				// focusedInput:focusedInput
				selectBtnLabel: (startDate && endDate) ? (`${startDate.format('DD MMM')} - ${endDate.format('DD MMM')}`)
					: TranslationHelper.getValue('customer_account.dateRangeSelector.selectDates'),
				availableToClearDates: true,

			});
		}
	}

	onFocusChange(focusedInput) {
		if (focusedInput) {
			this.setState({ focusedInput, prevFocusedInput: focusedInput });
		} else {
			this.setState({ focusedInput: null, prevFocusedInput: null });
		}
		if (focusedInput === 'startDate' && this.state.prevFocusedInput !== 'startDate' && this.updatable) {
			this.updatable = false;
			setTimeout(() => {
				const dateRangePicker = document.getElementsByClassName('DateRangePicker_picker')[0];

				if (dateRangePicker) {
					dateRangePicker.style.left = `${Number(dateRangePicker.style.left.split('.')[0]) - 30}px`;
				}
				this.updatable = true;
			}, 250);
		}
	}

	onSingleDateFocusChange({ focused }) {
		this.setState({ focused });
		if (focused && this.state.prevFocused !== 'startDate' && this.updatable) {
			this.updatable = false;
			setTimeout(() => {
				const singleDatePicker = document.getElementsByClassName('SingleDatePicker_picker')[0];

				if (singleDatePicker) {
					singleDatePicker.style.left = `${Number(singleDatePicker.style.left.split('.')[0]) - 30}px`;
				}
				this.updatable = true;
			}, 250);
		}
	}

	/** *********** handler method for SingleDatePicker *********** */
	handleSingleDateChange(date) {
		const {
			callback, mobileModalVisible, setMobileModalVisibility, pageActiveCallback
		} = this.props;
		if (!isMobile) {
			$('#selectBtn').trigger('click'); // .removeClass('inlineDisplay').addClass('hide');
		}
		this.setState({
			singleDate: date,
			selectBtnLabel: date ? date.format('DD MMM YYYY') : TranslationHelper.getValue('customer_account.dateRangeSelector.selectDates'),
			focused: false,
			availableToClearDates: true,
		});
		if (callback && date) {
			if (mobileModalVisible) {
				setMobileModalVisibility(false);
			}
			callback({ singleDate: date.toDate() });
			this.handleClose();
		} else if (callback) {
			if (mobileModalVisible) {
				setMobileModalVisibility(false);
			}
			pageActiveCallback && pageActiveCallback(1);
			callback({}, true, false);
		}
	}

	onDatesChange({ startDate, endDate }) {
		const { selectRangeOption } = this.state;

		if (this.state.focusedInput === 'endDate' && endDate && selectRangeOption === 'Days') {
			const showDateRangeError = false;
			const dateRangeErrorText = '';
			
			if (showDateRangeError) {
				this.setState({ showDateRangeError, dateRangeErrorText });
				this.props.callback({ dateRange: { startDate: null, endDate: null } });
				return;
			}
		}
		this.handleDayChange({ startDate, endDate });
		if (startDate && endDate) {
			this.handleClose();
		}
	}

	render() {
		const { searchComponents } = this.props || {};
		const { calendar } = (
			searchComponents && searchComponents.otherSettings && searchComponents.otherSettings.filter
		) || {};
		if (calendar === 'none') return null;
		return (
			<>
				<SweetAlert
					show={this.state.showDateRangeError}
					title={TranslationHelper.getValue('customer_account.productMain.sweetAlert.title')}
					text={this.state.dateRangeErrorText}
					onConfirm={() => this.setState({ showDateRangeError: false })}
				/>
				{ this.props.showTriggerButton
					? (
						<div>
							<Popover
								open={Boolean(this.state.anchorEl)}
								anchorEl={this.state.anchorEl}
								onClose={this.handleClose}
								anchorOrigin={{
									vertical: 'bottom',
									horizontal: 'left',
								}}
								transformOrigin={{
									vertical: 'top',
									horizontal: 'left',
								}}
								disableScrollLock="true"
								PaperProps={{
									style: { minWidth: UIHelper.mobileWindowCheck() || !this.state.showDateRange ? '157px' : '274px', overflow: 'visible', padding: '10px 0px' },
								}}
							>
								{(this.state.showDateRange)
									? (
										<DateRangePicker
											horizontalMargin={20}
											startDate={this.state.startDate} // momentPropTypes.momentObj or null,
											startDateId="your_unique_start_date_id" // PropTypes.string.isRequired,
											endDate={this.state.endDate} // momentPropTypes.momentObj or null,
											endDateId="your_unique_end_date_id" // PropTypes.string.isRequired,
											onDatesChange={this.onDatesChange} // PropTypes.func.isRequired,
											focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
											onFocusChange={this.onFocusChange} // PropTypes.func.isRequired,
											noBorder
											showClearDates
											disabled={this.state.readOnly}
											numberOfMonths={UIHelper.mobileWindowCheck() ? 1 : 2}
											startDatePlaceholderText="From"
											endDatePlaceholderText="Until"
											readOnly
											minimumNights={0}
											displayFormat={UIHelper.getLocaleDateString()}
											appendToBody={(this.props.showOnBody) ? this.props.showOnBody : false}
											// autoFocus={(this.props.showOnBody)?this.props.showOnBody:false}
											// autoFocusEndDate={(this.props.showOnBody)?this.props.showOnBody:false}
											block={(this.props.showOnBody) ? this.props.showOnBody : false}
										/>
									)
									: (
										<SingleDatePicker
											horizontalMargin={20}
											date={this.state.singleDate} // momentPropTypes.momentObj or null
											onDateChange={(date) => {
												this.handleSingleDateChange(date);
											}} // PropTypes.func.isRequired
											focused={this.state.focused}// PropTypes.bool
											onFocusChange={this.onSingleDateFocusChange} // PropTypes.func.isRequired
											id="your_unique_start_date_id" // PropTypes.string.isRequired,
											readOnly
											reopenPickerOnClearDate
											displayFormat={UIHelper.getLocaleDateString()}
											noBorder
											disabled={this.state.readOnly}
											regular
											numberOfMonths={1}
											// appendToBody={(this.props.showOnBody)?this.props.showOnBody:false}
											block={(this.props.showOnBody) ? this.props.showOnBody : false}
										/>
									)}
							</Popover>
							<Button
								variant="outlined"
								color={this.state.selectBtnLabel === TranslationHelper.getValue('customer_account.dateRangeSelector.selectDates') ? 'primary' : 'secondary'}
								style={{ outline: 0, marginRight: '5px' }}
								onClick={(e) => {
									setTimeout(() => {
										document.getElementById('your_unique_start_date_id').focus();
									}, 25); this.handleClick(e);
								}}
							>
								{this.state.selectBtnLabel}
							</Button>
						</div>
					)
					: this.state.showDateRange
						? (
							<div style={{ minWidth: UIHelper.mobileWindowCheck() || !this.state.showDateRange ? '157px' : '274px', overflow: 'visible', zIndex: 1300 }}>
								<DateRangePicker
									horizontalMargin={20}
									startDate={this.state.startDate} // momentPropTypes.momentObj or null,
									startDateId="your_unique_start_date_id" // PropTypes.string.isRequired,
									endDate={this.state.endDate} // momentPropTypes.momentObj or null,
									endDateId="your_unique_end_date_id" // PropTypes.string.isRequired,
									onDatesChange={this.onDatesChange} // PropTypes.func.isRequired,
									focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
									onFocusChange={this.onFocusChange} // PropTypes.func.isRequired,
									noBorder
                                    showClearDates={this.state.showClearDates}
                                    isDayBlocked={this.isDayBlocked}
									disabled={this.state.readOnly}
									numberOfMonths={UIHelper.mobileWindowCheck() ? 1 : 2}
									startDatePlaceholderText="From"
									endDatePlaceholderText="Until"
									readOnly
									minimumNights={0}
									displayFormat={UIHelper.getLocaleDateString()}
									appendToBody={(this.props.showOnBody) ? this.props.showOnBody : false}
									// autoFocus={(this.props.showOnBody)?this.props.showOnBody:false}
									// autoFocusEndDate={(this.props.showOnBody)?this.props.showOnBody:false}
									block={(this.props.showOnBody) ? this.props.showOnBody : false}
								/>
							</div>
						)
						: (
							<div className="singleDateSelector">
								<SingleDatePicker
									placeholder={TranslationHelper.getValue('customer_account.singeDatePicker.placeholder')}
									date={this.state.singleDate} // momentPropTypes.momentObj or null
									onDateChange={(date) => {
										this.handleSingleDateChange(date);
									}} // PropTypes.func.isRequired
									focused={this.state.focused}// PropTypes.bool
									onFocusChange={this.onSingleDateFocusChange} // PropTypes.func.isRequired
									id="singlePicker" // PropTypes.string.isRequired,
									readOnly
									displayFormat={UIHelper.getLocaleDateString()}
									noBorder
									reopenPickerOnClearDate
									disabled={this.state.readOnly}
									regular
									isDayBlocked={this.isDayBlocked}
									numberOfMonths={UIHelper.mobileWindowCheck() ? 1 : 2}
									appendToBody={(this.props.showOnBody) ? this.props.showOnBody : false}
									block={(this.props.showOnBody) ? this.props.showOnBody : false}
								/>
							</div>
						)}
			</>
		);
	}
}
